<template>
  <div>
    <el-dialog :visible.sync="centerDialogVisible" :append-to-body="true" :width="width" center>
      <div class="del_title">{{title}}</div>
      <span>{{message}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel_del">取 消</el-button>
        <el-button type="primary" @click="sure_del">确 定</el-button>
      </span>
    </el-dialog>

    <!-- <promptMessage ref="promptMessage" :title="prompt_title" :isTrue="prompt_istrue"></promptMessage> -->
  </div>
</template>

<script>
// import promptMessage from "./proment.vue";

export default {
  components: {
    // promptMessage
  },
  data() {
    return {
      centerDialogVisible: false,
      row: Boolean,
    };
  },
  props: {
    title: {
      type: String,
      default: "是否删除该组织?"
    },
    message: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "18%"
    },
    titleMessage:{
      type:String,
      default:'删除'
    },

  },
  watch: {
    titleMessage() {
      this.titleMessage
    }
  },
  methods: {
    cancel_del() {
      this.centerDialogVisible = false;
    },
    sure_del() {
      this.centerDialogVisible = false;
      this.$emit("isOk", this.row);
    },
    query(row){
      this.row = row
      this.centerDialogVisible = true
    }
  }
};
</script>

<style lang="less" scoped>
.del_title {
  font-size: 18px;
  font-weight: bold;
  color: rgba(72, 72, 72, 1);
  line-height: 28px;
  margin-bottom: 10px;
}
::v-deep.el-dialog__header {
  padding: 0px;
}
::v-deep.el-dialog__body {
  padding-top: 45px !important;
  padding-bottom: 10px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>